import { FC, JSX, useState } from "react";
import { Box, Button, Flex, Text, TextArea } from "@radix-ui/themes";
import "react-calendar/dist/Calendar.css";
import { Timestamp } from "firebase/firestore";
import Alert from "@/components/Alert/Alert";
import { Profile, ProfileOnboarding } from "@/models/Profile.model";

interface ProfileFormProps {
  initialValues: Profile;
  onSubmit: ((values: Profile) => void) | ((values: ProfileOnboarding) => void);
  loading: boolean;
  error?: { message?: string } | null;
  submitButtonText?: string;
}

const ProfileAboutForm: FC<ProfileFormProps> = ({
  initialValues,
  onSubmit,
  loading,
  error,
  submitButtonText = "Submit",
}): JSX.Element => {
  const [values, setValues] = useState<Profile>(initialValues);

  const setFormValue = (
    targetName: string,
    value: string | boolean | Timestamp
  ) => {
    return setValues((prev) => ({
      ...prev,
      [targetName]: value,
    }));
  };

  return (
    <Flex direction="column" gap="4">
      <Flex direction="column" gap="1">
        <Text as="label" size="2">
          Tell us about yourself
        </Text>
        <TextArea
          value={values.about || ""}
          rows={5}
          onChange={(e) => {
            setFormValue("about", e.target.value);
          }}
        />
      </Flex>

      {error && error.message && <Alert>{error.message}</Alert>}

      <Box>
        <Button
          onClick={() => {
            if (!loading) {
              onSubmit(values as Profile);
            }
          }}
        >
          {loading ? "Processing..." : submitButtonText}
        </Button>
      </Box>
    </Flex>
  );
};

export default ProfileAboutForm;
